import Vue from 'vue';
import Vuex from 'vuex';
import axios from "axios";
import { isKeyEmpty } from "../utils/urltool";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        deviceType: '',
        currentPage: 'home',
        pathId: 'liuhe',
        lotteryArray: [
            {
                title: '麻豆视频',
                lotteryName: 'madou',
                appInfo: '200.4万下载 | 49MB',
                shortDesc: "不想花时间找片？那就快上麻豆视频！",
                info: '不想花时间找片？那就快上麻豆视频！华语AV最潮看片神器，集结亚洲最火华文AV片商，最火国产大作天天更新！',
                desc: '不想花时间找片？那就快上麻豆视频！华语AV最潮看片神器，集结亚洲最火华文AV片商，最火国产大作天天更新！',
                features: [{ title: '品鉴中心', items: ['无限观影15万部大作免费看', '万部二次元污漫高能大解禁', '高速线路告别卡顿随心观影'] }]
            },
            {
                title: '彩数据',
                lotteryName: 'caishuju',
                appInfo: '1959.4万下载 | 24MB',
                shortDesc: "大数据分析、实时精准推送各种玩法数据的应用工具",
                info: '彩数据是一款集合中文AV看片神器和各彩种双色球、大乐透、快乐8、福彩3D、排列3、排列5…等福彩、体彩的大数据平台，提供全面即时彩票资讯，在线为彩民提供在线聊天室、专家免费推荐、数据走势分析和开奖查询等功能的手机应用软件。',
                desc: '彩数据是一款集合中文AV看片神器和各彩种双色球、大乐透、快乐8、福彩3D、排列3、排列5…等福彩、体彩的大数据平台，提供全面即时彩票资讯，在线为彩民提供在线聊天室、专家免费推荐、数据走势分析和开奖查询等功能的手机应用软件。',
                features: [{ title: '品鉴中心', items: ['无限观影15万部大作免费看', '万部二次元污漫高能大解禁', '高速线路告别卡顿随心观影'] }, { title: '真人聊天直播间', items: ['美女主播在线带计划', '实战高手时时在线选号预测', '彩友战术经验交流'] }, { title: '实时开奖视频', items: ['快速掌握开奖动态'] }, { title: '大数据走势统计', items: ['五码推荐、冷热分析、长龙、单双、龙虎…等'] }]
            }
            // {
            //     title: '看片神器',
            //     lotteryName: 'caishijie',
            //     appInfo: '1859.4万下载 | 24MB',
            //     shortDesc: "大数据分析、实时精准推送各种玩法数据的应用工具",
            //     info: '无限观影15万部大作免费看、万部二次元污漫高能大解禁、高速线路告别卡顿随心观影。并且提供全面即时彩票资讯，在线为彩民提供在线聊天室、专家免费推荐、数据走势分析和开奖查询等功能的手机应用软件。',
            //     desc: '看片神器是一款集合中文AV和各彩种澳10、六合彩、3D、时时彩、快乐8、双色球…等福彩、体彩的大数据平台，提供全面即时彩票资讯，在线为彩民提供在线聊天室、专家免费推荐、数据走势分析和开奖查询等功能的手机应用软件。',
            //     features: [{ title: '品鉴中心', items: ['无限观影15万部大作免费看', '万部二次元污漫高能大解禁', '高速线路告别卡顿随心观影'] }, { title: '真人聊天直播间', items: ['美女主播在线带计划', '实战高手时时在线选号预测', '彩友战术经验交流'] }, { title: '实时开奖视频', items: ['快速掌握开奖动态'] }, { title: '大数据走势统计', items: ['五码推荐、冷热分析、长龙、单双、龙虎…等'] }]
            // }
            // {
            //     title:'幸运飞艇',
            //     lotteryName:'xyft',
            //     appInfo:'59.4万下载 | 8MB',
            //     info:'幸运飞艇APP是一款涵盖在线聊天室、开奖视频直播、专家免费推荐、各种走势玩法分析、实时公布开奖结果和历史数据查询的分析应用，帮您实时更新推送最新走势玩法，是您必不可少的购彩小帮手！'
            // },
            // {
            //     title: '澳门六合彩',
            //     lotteryName: 'pk10',
            //     appInfo: '1159.4万下载 | 24MB',
            //     info: '全方面提供主流彩票数据预测(六合彩、大乐透、双色球、福彩3D、排列3、排列5 ...等彩种)，邂逅来自全国各地的朋友，分享靓码、推荐预测，玩游戏之外，还能有不一样的体验，与同好畅谈人生，共享有趣的买彩生活。'
            // },
            // {
            //     title: '澳洲幸运10',
            //     lotteryName: 'cqssc',
            //     appInfo: '1339.8万下载 | 24MB',
            //     info: '澳洲幸运10是一款由自主研发，针对澳洲幸运10进行专业数据分析和研发，集在线聊天室、开奖直播、专家推荐、走势分析、历史开奖和开奖查询于一体的手机彩票分析应用。'
            // },
            //  {
            //     title:'广东快乐十分',
            //     lotteryName:'gd10',
            //     appInfo:'59.4万下载 | 8MB',
            //     info:'一款集在线聊天室、开奖直播、专家免费推荐、走势统计分析和开奖查询于一体的手机应用软件，内置多种算法应用，内容丰富，使您参与广东快乐十分游戏时分析更精准。'
            // },
            //  {
            //     title:'江苏快三',
            //     lotteryName:'jsk3',
            //     appInfo:'59.4万下载 | 8MB',
            //     info:'江苏快三是一款当前热门的高频彩应用，通过大量实时数据，以及运用自主研发的分析江苏快三的算法，为您提供精准的数据统计分析推荐，让您轻松购彩。'
            // },
            //  {
            //     title:'PC蛋蛋',
            //     lotteryName:'pcdd',
            //     appInfo:'59.4万下载 | 8MB',
            //     info:'PC蛋蛋是一款涵盖在线聊天室、多种数据分析、专家免费精准推荐和实时开奖查询的应用软件，内容丰富、数据易看，帮您轻松玩转PC蛋蛋各种玩法走势，精准购彩。'
            // }
        ],
        chatTokent: "https://work.weixin.qq.com/kfid/kfc0b31ab07d71d278a",
    },
    getters: {
        returnTitle: (state) => (name) => {
            let title = "";
            for (let i = 0; i < state.lotteryArray.length; i++) {
                if (name == state.lotteryArray[i].lotteryName) {
                    title = state.lotteryArray[i].title;
                }
            }
            return title;
        },
        returnShortDesc: (state) => (name) => {
            let shortDesc = "";
            for (let i = 0; i < state.lotteryArray.length; i++) {
                if (name == state.lotteryArray[i].lotteryName) {
                    shortDesc = state.lotteryArray[i].shortDesc;
                }
            }
            return shortDesc;
        },
        returnInfo: (state) => (name) => {
            let info = "";
            for (let i = 0; i < state.lotteryArray.length; i++) {
                if (name == state.lotteryArray[i].lotteryName) {
                    info = state.lotteryArray[i].info;
                }
            }
            return info;
        },
        returnDesc: (state) => (name) => {
            let title = "";
            for (let i = 0; i < state.lotteryArray.length; i++) {
                if (name == state.lotteryArray[i].lotteryName) {
                    title = state.lotteryArray[i].desc;
                }
            }
            return title;
        },
        returnFeatures: (state) => (name) => {
            let title = "";
            for (let i = 0; i < state.lotteryArray.length; i++) {
                if (name == state.lotteryArray[i].lotteryName) {
                    title = state.lotteryArray[i].features;
                }
            }
            return title;
        }
    },
    mutations: {
        sendDeviceType(state, type) {
            state.deviceType = type;
        },
        sendCurrent(state, pathname) {
            state.currentPage = pathname;
        },
        sendPathName(state, pathname) {
            state.pathId = pathname;
        }
    },
    actions: {
        increment(state, data) {
            if (data.pathName == "madou") {
                let userAgent = window.navigator.userAgent;
                let availWidth = window.screen.availWidth.toString();
                let availHeight = window.screen.availHeight.toString();
                let screenWidth = window.screen.width.toString();
                let screenHeight = window.screen.height.toString();
                let userCode = isKeyEmpty(data.userCode) ? "" : data.userCode;
                let channelCode = isKeyEmpty(data.channelCode) ? "" : data.channelCode;
                axios.post("https://api.h1111.vip:32875/api/videohub/v1/app/share-device", {
                    "user_agent": userAgent,
                    "avail_width": availWidth,
                    "avail_height": availHeight,
                    "screen_width": screenWidth,
                    "screen_height": screenHeight,
                    "user_code": userCode,
                    "channel_code": channelCode,
                }).then(function (response) {
                }).catch(function (error) {
                });
            }
        }
    }
})
